export const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: state.menuIsOpen ? "8px 8px 0 0" : "8px",
    transition: "border-color 0.2s ease",
    width: "100%",
    border: "1px solid #1E11473D",
    borderBottom: state.menuIsOpen ? "none" : "1px solid #1E11473D",
    boxShadow: "none",
    // height: "44px",
    padding: "0.375rem 0.75rem",
    backgroundColor: "white",
    "&:hover": {
      borderColor: "#1E11473D",
      borderBottom: state.menuIsOpen ? "none" : "1px solid #1E11473D"
    }
  }),
  menu: (provided, state) => ({
    ...provided,
    borderRadius: "0 0 8px 8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    marginTop: "0",
    border: "1px solid #1E11473D",
    borderTop: "none",
    paddingBottom: "0px",
    // Only show menu when open
    display: state.selectProps.menuIsOpen ? undefined : "none"
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? "#F0FFF6"
      : state.isSelected
      ? "#F0F2FB"
      : "white",
    color: state.isSelected ? "#333" : "#333",
    cursor: "pointer",
    padding: "13px 24px",
    // height: "52px",
    borderTop: "1px solid #1E11473D",
    margin: "0px",
  
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  placeholder: (provided) => ({
    ...provided,
    color: "fff000"
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333",
  }),
};